import React, { useEffect, useState } from 'react'
import {  useDispatch } from 'react-redux'
import { setLanguage } from 'actions'

interface UrlLanguageProps {
  params: { language: string }
  languages: object
  children?: any // todo figure out what type this should be?
}

export function UrlLanguage({
  params,
  languages,
  children,
}: UrlLanguageProps) {
  const [currentLanguage, setCurrentLanguage] = useState<string>(
    params.language
  )
  const dispatch: any = useDispatch()
  const changeLanguage = (language: string) => {
    if (language && language in languages) {
      setCurrentLanguage(language)
      dispatch(setLanguage(language))
    } else {
      // Fallback to english
      setCurrentLanguage('en')
      dispatch(setLanguage('en'))
    }
  }

  useEffect(() => {
    changeLanguage(params?.language)
  }, [])

  useEffect(() => {
    if (params.language !== currentLanguage) {
      changeLanguage(params?.language)
    }
  }, [params.language])

  return children || null
}

export default UrlLanguage
